import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import type { TranslationKey } from '~/shared/internationalization/translation';
import { Button } from '~/ui/core/button/Button';
import { EmptyStateMessage } from '~/ui/core/empty-state-message/EmptyStateMessage';

export const QueryError: FunctionComponent<{
    readonly isRetrying: boolean;
    readonly message: TranslationKey;
    readonly onRetry: () => void;
}> = ({ isRetrying, message, onRetry }) => {
    const translate = useTranslate();

    return (
        <div className="flex flex-col items-center gap-m py-xl" role="alert">
            <EmptyStateMessage>{translate(message)}</EmptyStateMessage>
            <Button disabled={isRetrying} size="sm" variant="secondary" onClick={onRetry}>
                {translate('pages.ai-transformation.chart.retry')}
            </Button>
        </div>
    );
};
